const institutions = {
  id: "institutions",
  label: "Institutions",
  endpoint: "institutions",
  columnConfig: [
    {
      field: "name",
      headerName: "Institution",
      width: 250,
      description: "Institution",
      editable: true,
    },
  ],
  hiddenColumns: ["id"],
  chipConfig: {},
  tagConfig: {},
};

export default institutions;
